export default {"src":"/_next/static/media/image6_en.da8199c4.svg","height":258,"width":359,"blurWidth":0,"blurHeight":0};